import React, { useEffect, useState } from "react";
import addIcon from "../../../assets/utils/images/add_icon.png";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import classnames from "classnames";
import {
  Button,
  Card,
  CardHeader,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import TabOrganizationOverview from "./components/TabOrganizationOverview";
import TabOrganizationMission from "./components/TabOrganizationMission";
import TabPublishedInformation from "./components/TabPublishedInformation";
import { useMutation, useQuery } from "@apollo/client";
import {
  QUERY_MY_SUPPORTER_INFO,
  UPDATE_SUPPORTER_LOGO,
} from "../../../queries";
import { sendGAEvent } from "../../../utils";
import TabMembersList from "./components/TabMembersList";

const SettingOrgInfoSupporter = () => {
  const [orgActiveTab, setOrgActiveTab] = useState("1");
  const [modalUploadIcon, setModalUploadIcon] = useState(false);
  const [logo, setLogo] = useState();
  const local = localStorage.getItem("tab");

  const supporterInfo = useQuery(QUERY_MY_SUPPORTER_INFO);
  const [updateLogo] = useMutation(UPDATE_SUPPORTER_LOGO, {
    onCompleted: () => {
      setModalUploadIcon(false);
      setLogo();
      supporterInfo?.refetch();
    },
  });

  function handleChangeTab(tab) {
    if (orgActiveTab !== tab) setOrgActiveTab(tab);
  }

  function onSelectImageFile(e) {
    if (e.currentTarget.files !== null) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        setLogo({
          name: file.name,
          file: e.target.result,
        });
      };
      // 必須
      reader.readAsDataURL(file);
    }
  }

  const upload = async () => {
    await updateLogo({
      variables: { icon: logo },
    });
  };

  useEffect(() => {
    const tab = localStorage?.getItem("tab");
    if (tab) {
      setOrgActiveTab(tab);
      localStorage.removeItem("tab");
      localStorage.removeItem("tabActive");
    } else return;
  }, []);

  return (
    <CSSTransitionGroup
      component="div"
      transitionName="TabsAnimation"
      transitionAppear={true}
      transitionAppearTimeout={0}
      transitionEnter={false}
      transitionLeave={false}
    >
      <Card className="mb-3">
        <CardHeader className="org_title">
          {/* <img
                        src={supporterInfo?.data?.mySupporterInfo?.edges[0]?.node?.logoUrl}
                        alt=""
                        className="profile-blur opacity-9"
                        style={{ width: "40px", cursor: "pointer" }}
                    /> */}
          {supporterInfo?.data?.mySupporterInfo?.edges[0]?.node?.logoUrl ? (
            <img
              src={
                supporterInfo?.data?.mySupporterInfo?.edges[0]?.node?.logoUrl
              }
              alt=""
              className="profile-blur opacity-9"
              style={{ width: "40px", height: "40px", cursor: "pointer" }}
              onClick={() => setModalUploadIcon(true)}
            />
          ) : (
            <div>
              <img
                src={addIcon}
                style={{ width: "55px", cursor: "pointer" }}
                onClick={() => setModalUploadIcon(true)}
              />
            </div>
          )}
          <h4 className="org_name">
            {supporterInfo?.data?.mySupporterInfo?.edges[0]?.node?.name}
          </h4>
        </CardHeader>
      </Card>

      <Card className="mb-2 original-card__sp">
        <CardHeader className="card-header-tab">
          <Nav>
            <NavItem>
              <NavLink
                className={classnames({ active: orgActiveTab === "1" })}
                onClick={() => {
                  handleChangeTab("1");
                }}
              >
                組織概要
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: orgActiveTab === "2" })}
                onClick={() => {
                  handleChangeTab("2");
                  sendGAEvent(
                    "pageview",
                    "/#/dashboards/plofile-organization/mission_and_collaboration_policy_tab"
                  );
                }}
              >
                ミッションと連携方針
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: orgActiveTab === "3" })}
                onClick={() => {
                  handleChangeTab("3");
                  sendGAEvent(
                    "pageview",
                    "/#/dashboards/plofile-organization/public_informationv_tab"
                  );
                }}
              >
                情報開示と第三者認証
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: orgActiveTab === "4" })}
                onClick={() => {
                  handleChangeTab("4");
                  sendGAEvent(
                    "pageview",
                    "/#/dashboards/plofile-organization/member_list_tab"
                  );
                }}
              >
                契約プランとメンバー
              </NavLink>
            </NavItem>
          </Nav>
        </CardHeader>
      </Card>

      <TabContent activeTab={orgActiveTab} className="card-tab">
        <TabPane tabId="1">
          <TabOrganizationOverview />
        </TabPane>
        <TabPane tabId="2">
          <TabOrganizationMission />
        </TabPane>
        <TabPane tabId="3">
          <TabPublishedInformation />
        </TabPane>
        <TabPane tabId="4">
          <TabMembersList />
        </TabPane>
      </TabContent>

      <Modal isOpen={modalUploadIcon} toggle={() => setModalUploadIcon(false)}>
        <ModalHeader
          toggle={() => setModalUploadIcon(false)}
          style={{ backgroundColor: "white", border: "none" }}
        ></ModalHeader>
        <ModalBody className="ml-3 mr-3">
          <p className="bold">組織アイコンを登録</p>
          <input type="file" onChange={onSelectImageFile} />
        </ModalBody>
        <ModalFooter style={{ background: "#fff", borderTop: "none" }}>
          <Button onClick={upload} className="main_button">
            登録
          </Button>
        </ModalFooter>
      </Modal>
    </CSSTransitionGroup>
  );
};

export default SettingOrgInfoSupporter;
